import { Stack } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { useMount } from 'ahooks';
import { useAuthUser } from '../../../api';
import { ComputeCostOverviewTabController } from '../../../features/Overview/ComputeCostOverviewTabController';

export function JobComputeCostPage() {
	const { user } = useAuthUser();

	useMount(() => {
		trackEvent('job_compute_cost_page/view', {}, user, undefined);
	});

	return (
		<Stack>
			<ComputeCostOverviewTabController />
		</Stack>
	);
}
